// LLM generated - Model Claude 4 Sonnet
type IconTagAuroraProps = {
  size?: number;
  strokeWidth?: number;
};

export default function IconTagAurora({ size = 28, strokeWidth = 2.5 }: IconTagAuroraProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.76648 14.4744V6.16191C4.76648 5.57553 5.24184 5.10016 5.82823 5.10016H14.1407C14.4223 5.10016 14.6924 5.21202 14.8914 5.41114L24.189 14.7087C24.6036 15.1233 24.6036 15.7955 24.189 16.2102L15.8765 24.5227C15.4618 24.9373 14.7896 24.9373 14.3749 24.5227L5.07746 15.2251C4.87835 15.026 4.76648 14.7559 4.76648 14.4744Z"
        stroke="url(#paint0_linear_tag_aurora)"
        strokeWidth={strokeWidth}
      />
      <path
        d="M10.4999 12C11.1443 12 11.6666 11.4777 11.6666 10.8333C11.6666 10.189 11.1443 9.66666 10.4999 9.66666C9.85561 9.66666 9.33328 10.189 9.33328 10.8333C9.33328 11.4777 9.85561 12 10.4999 12Z"
        stroke="url(#paint1_linear_tag_aurora)"
        strokeWidth={strokeWidth}
      />
      <defs>
        <linearGradient
          id="paint0_linear_tag_aurora"
          x1="4.76648"
          y1="14.9669"
          x2="24.4999"
          y2="14.9669"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BC4CF" />
          <stop offset="1" stopColor="#7F1A93" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_tag_aurora"
          x1="4.76648"
          y1="14.9669"
          x2="24.4999"
          y2="14.9669"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BC4CF" />
          <stop offset="1" stopColor="#7F1A93" />
        </linearGradient>
      </defs>
    </svg>
  );
}

IconTagAurora.displayName = 'IconTagAurora';
